import {
  trackAppOpen,
  trackInstallCompleted,
  trackInstallPromptDismissed,
  trackInstallPromptShown,
  trackPwaInstall,
  trackUpdateAvailable,
  trackUpdateInstalled,
} from "../service/analyticsService";

let bannerShown = false;

export function wirePwaAnalytics() {
  trackAppOpen();

  const onInstalled = () => {
    trackPwaInstall();
    trackInstallCompleted();
  };
  window.addEventListener("appinstalled", onInstalled);

  return () => {
    window.removeEventListener("appinstalled", onInstalled);
  };
}

export function notifyInstallBannerVisible() {
  if (bannerShown) return;
  bannerShown = true;
  trackInstallPromptShown();
}

export function notifyInstallBannerDismissed() {
  trackInstallPromptDismissed();
}

export function notifyNativeInstallAccepted() {
  trackInstallCompleted();
  trackPwaInstall();
}

export function notifyServiceWorkerUpdateAvailable(source = "sw") {
  trackUpdateAvailable({ update_source: source });
}

export function notifyServiceWorkerUpdateInstalled(source = "sw") {
  trackUpdateInstalled({ update_source: source });
}

export function resetPwaAnalyticsStateForTests() {
  bannerShown = false;
}
